import React, { useState } from "react";
import { RefCard } from "../../betTablePoker/refParts";

/**
 * Video card overlay for Teenpatti Open (teen8), Poker 1-Day (poker) and Poker 6 Players (poker6),
 * reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container > ...
 *     teen8:  .dealer-name.justify-content-start "Dealer" + div > cards[8], cards[17], cards[26]
 *     poker:  .playerboardcards > .dealer-name.w-100.mb-1 "Board" + .d-flex > cards[4..8]
 *     poker6: div > cards[12..16]
 * Hidden (hide-cards) while the key card is a back ("1"); the shuffle handle toggles it.
 */
export default function PokerCardsOverlay({ card, variant = "poker" }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || card === "") return null;
  const cards = String(card).split(",").map((c) => c.trim());
  if (!cards.length) return null;
  const keyCard = variant === "poker6" ? cards[12] : cards[0];
  const hidden = !showCards || keyCard === "1";

  if (keyCard === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const list = (idx) =>
    idx.map((i, n) => (
      <React.Fragment key={i}>
        {n > 0 && " "}
        <RefCard card={cards[i]} />
      </React.Fragment>
    ));

  let content;
  if (variant === "teen8") {
    content = (
      <>
        <div className="dealer-name justify-content-start">Dealer</div> <div>{list([8, 17, 26])}</div>
      </>
    );
  } else if (variant === "poker6") {
    content = <div>{list([12, 13, 14, 15, 16])}</div>;
  } else {
    content = (
      <div className="playerboardcards">
        <div className="dealer-name w-100 mb-1">Board</div> <div className="d-flex">{list([4, 5, 6, 7, 8])}</div>
      </div>
    );
  }

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">{content}</div>
    </div>
  );
}
